import React, { useEffect, useState } from 'react';
import DiscussForm from '../components/DiscussForm';
import videoDark from '../images/Coming Soon (Black).mp4';
import videoLight from '../images/Coming Soon (Black with White BG).mp4';

function FacilityManagement() {
    const [theme, setTheme] = useState('light');

    useEffect(() => {
        window.scrollTo(0, 0);

        const getTheme = () =>
            document.documentElement.getAttribute('data-theme') === 'dark' ? 'dark' : 'light';

        setTheme(getTheme());

        const observer = new MutationObserver(() => {
            setTheme(getTheme());
        });

        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['data-theme'],
        });

        return () => observer.disconnect();
    }, []);

    const videoSrc = theme === 'dark' ? videoDark : videoLight;

    return (
        <div className='location-main'>
            {/* Hero Section */}
            <div className='about-hero hyd-hero'>
                <div className='about-hero-inner d-flex justify-content-center align-items-center'>
                    <div>
                        <h1 className='syne-title'>Facility Management<span className='text-rose'>.</span></h1>
                        <p className='text-center'>
                            Home / Services / <span className='text-rose'>Facility Management</span>
                        </p>
                    </div>
                </div>
            </div>

            {/* Video Section */}
            <div className='video-section'>
                <video
                    key={videoSrc}
                    src={videoSrc}
                    autoPlay
                    muted
                    loop
                    playsInline
                    className='w-100 theme-video'
                />
            </div>

            {/* Discuss Form */}
            <DiscussForm />
        </div>
    );
}

export default FacilityManagement;
